import { TypePriceToggleWithoutUnresolvableLinksResponse } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import PriceToggle, { PriceToggleProps } from './PriceToggle'

const ContentfulPriceToggle = withContentful<
  TypePriceToggleWithoutUnresolvableLinksResponse['fields'],
  PriceToggleProps
>(PriceToggle, {
  priceLockupCoupon: (props) => props.fields?.priceLockupCoupon?.fields,
  priceLockupNoCoupon: (props) => props.fields?.priceLockupNoCoupon?.fields,
})

export default ContentfulPriceToggle
